import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "mailCheck"
const MailCheckIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.997 6.422A1.44 1.44 0 0 0 20.56 5H3.44A1.43 1.43 0 0 0 2 6.422v.27L11.999 12l9.998-5.309v-.27ZM20.624 12.5a2 2 0 0 1 1.376.549V8.74L12 14 2 8.74v8.84c0 .77.644 1.422 1.438 1.422h6.614a2 2 0 0 1 .334-2.387l1.323-1.323a2 2 0 0 1 2.829 0l1.233 1.232 3.438-3.438a2 2 0 0 1 1.415-.586Zm1.323 3.323-3.178 3.179L15.771 22l-2.999-2.998-.972-.973 1.324-1.323 2.295 2.296.352.35.351-.35 4.502-4.502 1.323 1.323Z"
      />
    </svg>
  )
}
export default MailCheckIcon
